interface NotificationIconProps {
  type: string;
}

export function NotificationIcon({ type }: NotificationIconProps) {
  const getIcon = () => {
    switch (type) {
      case "welcome":
        return "🎉";
      case "sponsor_invite":
        return "🤝";
      case "artist_invite":
        return "🎵";
      case "system_update":
        return "🔔";
      case "profile_completion":
        return "✅";
      case "profile_comment":
        return "💬";
      default:
        return "📬";
    }
  };

  return <div className="text-xl flex-shrink-0">{getIcon()}</div>;
}
